module.exports = __webpack_public_path__ + "img/MX-A018030A-AS-HQ.c34342bb.png";